import { Routes, Route } from "react-router-dom";
import Layout from "../common/components/Layout";
import About from "./about";
import Resume from "./resume";
import WritingSample from "./writing-sample";
import ContactPage from "./contact";
import TermsAndConditionsPage from "./terms-and-conditions";
import PrivacyPolicyPage from "./privacy-policy";
import HomePage from "./home";
import BuildNotes from "./build-notes";

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/writing-sample" element={<WritingSample />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      </Routes>
      <BuildNotes />
    </Layout>
  );
}

export default App;
